import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectPriceFilter } from 'shared/selectors/filters';

export const PriceContainer: FC = () => {
  const {
    value: { min, max },
  } = useSelector(selectPriceFilter);

  const onChange = useFilterChangeCallback();

  const handlePriceMinChange = useDebouncedCallback((gte: number | null) => {
    onChange({ action: 'setPriceMin', arguments: [gte] });
  });

  const handlePriceMaxChange = useDebouncedCallback((lte: number | null) => {
    onChange({ action: 'setPriceMax', arguments: [lte] });
  });

  return (
    <RangeInput
      min={0}
      max={999999999999}
      valueMin={min}
      valueMax={max}
      onChangeMin={handlePriceMinChange}
      onChangeMax={handlePriceMaxChange}
      allowMaxBelowMin
    />
  );
};
